export const TRACER_STATUS_CODE = {
    UNSET: 0,
    OK: 1,
    ERROR: 2,
};
